import {
  AttributeRangeDefinition,
  AttributeValueRange,
  AttributeValidationError,
  AttributeKeyArrayRangeDefinition,
  AttributeKeyEnumDefinition,
  AttributeKeyRangeDefinition,
  AttributeValidationResult,
  ValidationMap,
  ValidAttributeKeyDefinition,
} from '../Validation/validationTypes'
import { validAttributeNumberValue, validAttributeBooleanValue, validAttributeEnumValue, validAttributePresent } from '../Validation/validationCore'
import { validateNumberArray } from '../Validation/validationArray'

export const validateObject = <T>(item: Partial<T>, validationObject: AttributeRangeDefinition<T>): Partial<ValidationMap<T>> => {
  const res: Partial<ValidationMap<T>> = {}
  Object.entries(item).forEach(([k, v]) => {
    const key = k as keyof T
    const typeofItem = typeof v
    const validator = validationObject[key] as ValidAttributeKeyDefinition | undefined
    const isArray = v instanceof Array

    switch (validator?.attributeType) {
      case 'number':
        {
          res[key] = validAttributeNumberValue(v, (validator as AttributeKeyRangeDefinition).range)
        }
        break
      case 'array':
        {
          if (v instanceof Array) {
            res[key] = validateNumberArray(v, (validator as AttributeKeyArrayRangeDefinition).range)
          } else {
            console.log('unhandled case where array not provided')
          }
        }
        break
      case 'boolean':
        {
          res[key] = validAttributeBooleanValue(v)
        }
        break
      case 'enumeration':
        {
          res[key] = validAttributeEnumValue(v, (validator as AttributeKeyEnumDefinition).enumeration)
        }
        break
      case 'present':
        {
          res[key] = validAttributePresent(v)
        }
        break
      default: {
        const nextValidator = validationObject[key] as { [k2 in keyof T[keyof T]]: ValidAttributeKeyDefinition }
        const nextItem = v
        if (nextValidator && nextItem) {
          // @ts-ignore
          const nextRes = validateObject(nextItem, nextValidator)
          res[key] = nextRes as AttributeValidationResult | { [k2 in keyof T[keyof T]]: AttributeValidationResult } | undefined
        }
      }
    }
  })

  return res
}
